const KidsStatus = [
  // { value: '1', label: "I don't have" },
  { value: '1', label: "I don't have & don't want any" },
  { value: '2', label: "I don't have but want some" },
  { value: '3', label: 'I have but want more' },
  { value: '4', label: "I have & don't want more" }
];

export default KidsStatus;
